export default __webpack_public_path__ + "static/media/beginner-home.4cddf4e3.svg";